const state = {
    warehouses: [],
    warehouse: {},
    error: null
};

export default state;
